module.exports = __webpack_public_path__ + "static/img/no4.65e1aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no4.png
// module id = gP8g
// module chunks = 31